const green200Color = '#9CE2AC';

export default green200Color;
